import { concatStyleSets, memoizeFunction, mergeStyles } from "@fluentui/react";
import { flexChildSizeFixed } from "../../../utilities/Mixin.styles";
const taskCompleteButtonSize = "18px";
const taskCompleteButtonSpacing = "10px";
/**
 * Function to merge default styles with custom styles for the complete task button wrapper
 */ export const getCompleteTaskButtonWrapperItemClassNames = memoizeFunction((customStyles)=>{
    const defaultStyles = {
        requiredCompleteIcon: [
            "requiredCompleteIcon",
            flexChildSizeFixed(taskCompleteButtonSize),
            {
                marginRight: taskCompleteButtonSpacing,
                marginBottom: "auto"
            }
        ]
    };
    const styles = concatStyleSets(defaultStyles, customStyles);
    return {
        requiredCompleteIcon: mergeStyles("requiredCompleteIcon", styles.requiredCompleteIcon)
    };
});
